export default __webpack_public_path__ + "assets/calendar.4611a000.svg";